import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";

/** Encapsulates evidence upload + incident submission so the page component
 * only has to handle rendering and form state. */
export function useIncidentSubmit() {
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const submitIncident = async ({ category, title, description, location, incidentDate, files, contactPhone, preferredContactMethod, followUpConsent }) => {
    setError("");
    if (!category) {
      setError("Please choose a category");
      return;
    }
    setLoading(true);
    try {
      const evidence_paths = [];
      if (files.length) {
        setUploading(true);
        for (const file of files) {
          const formData = new FormData();
          formData.append("file", file);
          const { data } = await api.post("/uploads", formData, { headers: { "Content-Type": "multipart/form-data" } });
          evidence_paths.push(data.storage_path);
        }
        setUploading(false);
      }
      await api.post("/incidents", {
        category, title, description, location: location || null,
        incident_date: incidentDate || null, evidence_paths,
        contact_phone: contactPhone || null,
        preferred_contact_method: preferredContactMethod || null,
        follow_up_consent: followUpConsent,
      });
      setSubmitted(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    }
    setLoading(false);
  };

  const getSubmitLabel = () => {
    if (uploading) return "Uploading evidence...";
    if (loading) return "Submitting...";
    return "Submit Report";
  };

  return { submitIncident, uploading, loading, error, submitted, submitLabel: getSubmitLabel() };
}
